import Cookies from 'js-cookie';

const TOKEN_KEY = 'accessToken';

// อายุ token 10 นาที (หน่วย expires ของ js-cookie คือ "วัน")
// ต้องให้ตรงกับ idle timeout ใน App.js
export const TOKEN_EXPIRES_DAYS = 1 / (24 * 6);

// ใส่ secure เฉพาะตอนรันบน https เพราะ dev server เป็น http://localhost
// ถ้าใส่ตลอดเวลา browser จะทิ้ง cookie ทั้งใบตอน dev
const tokenAttributes = () => ({
  expires: TOKEN_EXPIRES_DAYS,
  sameSite: 'strict',
  secure: window.location.protocol === 'https:',
});

export const getAccessToken = () => Cookies.get(TOKEN_KEY);

// เซ็ตผ่านฟังก์ชันนี้เท่านั้น ถ้าเซ็ตเองโดยไม่ส่ง expires
// cookie จะกลายเป็น session cookie ที่อยู่ยาวจนปิด browser
export const setAccessToken = (accessToken) => Cookies.set(TOKEN_KEY, accessToken, tokenAttributes());

export const removeAccessToken = () => Cookies.remove(TOKEN_KEY);
